import Prismic from 'prismic-javascript';
import {
  COLLECTION_DOCUMENT_TYPE,
  PRISMIC_API_ENDPOINT_V2,
  PRISMIC_API_ENDPOINT_V2_TOKEN,
} from 'utils/Prismic/PrismicConstants';

export async function getCollections(): Promise<any> {
  const response = await Prismic.getApi(PRISMIC_API_ENDPOINT_V2, {
    accessToken: PRISMIC_API_ENDPOINT_V2_TOKEN,
  })
    .then((client) => {
      return client.query(
        Prismic.Predicates.at('document.type', COLLECTION_DOCUMENT_TYPE),
        { pageSize: 100, orderings: `[my.${COLLECTION_DOCUMENT_TYPE}.order]` },
      );
    })
    .catch((e) => {
      return null;
    });

  return response;
}
